import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './main/main.component';
import { MainOtherComponent } from './main-other/main-other.component';
import { FullLayoutComponent } from './_layout/full-layout/full-layout.component';
import { ListComponent } from './content/system/teacher/classroom/list/list.component';
const appRoutes: Routes = [
  // Public layout

  {
    path: '',
    component: FullLayoutComponent,
    children: [
      {
        path: '', component: MainComponent
      }
    ]
  },
  {
    path: 'others',
    component: FullLayoutComponent,
    children: [
      {
        path: '', component: MainOtherComponent
      }
    ]
  },
  {
    path: 'system',
    loadChildren: () => import('./content/system/system.module').then(m => m.SystemModule)
  },
  {
    path: 'student',
    loadChildren: () => import('./content/student/student.module').then(m => m.StudentModule)
  },
  {
    path: 'parent',
    loadChildren: () => import('./content/parent/parent.module').then(m => m.ParentModule)
  },
  {
    path: 'websocket',
    loadChildren: () => import('./ws/ws.module').then(m => m.WsModule)
  },
  {
    path: 'online',
    loadChildren: () => import('./content/room-online/room-online.module').then(m => m.RoomOnlineModule)
  },
  {
    path: 'monitor',
    loadChildren: () => import('./content/monitor/monitor.module').then(m => m.MonitorModule)
  },
  {
    path: 'register/dorm',
    loadChildren: () => import('./content/dorm/dorm.module').then(m => m.DormModule)
  },
  // {
  //   path: 'vote',
  //   loadChildren: () => import('./content/vote/vote.module').then(m => m.VoteModule)
  // },
  {
    path: 'reporting',
    loadChildren: () => import('./content/reporting/reporting.module').then(m => m.ReportingModule)
  },
  {
    path: 'admission-pre-test',
    loadChildren: () => import('./content/pre-test/pre-test.module').then(m => m.PreTestModule)
  },
  {
    path: 'security',
    loadChildren: () => import('./content/security-guard/security-guard.module').then(m => m.SecurityModule)
  },
  {
    path: 'pnc/booth-visit',
    loadChildren: () => import('./content/booth-visit/booth-visit.module').then(m => m.BoothVisitModule)
  },
  // {
  //   path: 'register/dorm/list',
  //   canActivate: [AuthAdmisGuard],
  //   loadChildren: () => import('./dashboard/dashboard.module').then(m => m.AdmisDashboardModule)
  // }
  // otherwise redirect to home
  // { path: '**', redirectTo: '' }
];

export const routing = RouterModule.forRoot(appRoutes, { scrollOffset: [0, 0], scrollPositionRestoration: 'top' });
